import { createUseStyles } from 'react-jss';
import { theme } from '@align-cpf/uikit-styles';

const { spacing } = theme;

export default createUseStyles(
  {
    root: {
      display: 'flex',
      width: '100%',
      gap: spacing.sp02,
    },

    vertical: {
      flexDirection: 'column',
    },
  },
  {
    name: 'Stepper',
  },
);
